console.log("custom recommended");
var mycRecElement = $(".c-recommended").get(0);
if(!($(".c-recommended label").hasClass("facet-checkbox"))) {
  console.log("adding class", $(".c-recommended label"), $(".c-recommended label").hasClass("facet-checkbox"));
  $(".c-recommended label").addClass("facet-checkbox form-label--checkbox");
  
}
var cRecObserver = new MutationObserver(function(mutations) {
  
  
  
   
    console.log("c-recommended mutation");
    setTimeout(function(){ 
      console.log($(".c-recommended label"), $(".c-recommended label").hasClass("facet-checkbox"));
      if(!($(".c-recommended label").hasClass("facet-checkbox"))) {
        console.log("adding class");
        $(".c-recommended label").addClass("facet-checkbox form-label--checkbox");
        cRecObserver.disconnect();
      }
      
    }, 200);
    
    //cRecObserver.disconnect();
    
    
    
});

cRecObserver.observe(mycRecElement, {attributes: false, childList: true, characterData: false, subtree:true});